module.exports = __webpack_public_path__ + "static/image/history/pc/202010.jpg?235a2c36";